<template>
  <div class="total_title">{{ title }}</div>
  <div v-if="type == 1">
    <ul class="u4 u4_tit u_title">
      <li class="u4-3">选项</li>
      <li class="u4-3" v-if="titleType == 1">人数</li>
      <li class="u4-3" v-if="titleType == 2">学校数</li>
      <li class="u4-3">比例</li>
    </ul>
    <div class="cnt_list">
      <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
        <li class="u4-3" v-if="item.type != -1">
          {{ format(item.type) || "未建队/未配备" }}
        </li>
        <li class="u4-3" v-if="item.type != -1">{{ item.total || 0 }}</li>
        <li class="u4-3" v-if="item.type != -1 && !totalType">{{ percentage(item.total) }}%</li>
        <li class="u4-3" v-if="item.type != -1 && totalType">{{  percentageTotal(item.total, list) }}%</li>
      </ul>
    </div>
  </div>
  <div v-if="type == 2">
    <ul class="u4 u4_tit u_title">
      <li class="u4-3">选项</li>
      <li class="u4-3">平均课时</li>
      <li class="u4-3">最大课时</li>
      <li class="u4-3">人数</li>
      <li class="u4-3">比例</li>
    </ul>
    <div class="cnt_list">
      <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
        <li class="u4-3">{{ format(item.concurrentCourses) }}</li>
        <li class="u4-3">{{ fixed(item.avgHour, 2) || 0 }}</li>
        <li class="u4-3">{{ item.maxHour || 0 }}</li>
        <li class="u4-3">{{ item.total || 0 }}</li>
        <li class="u4-3">{{ percentage(item.total) }}%</li>
      </ul>
    </div>
  </div>
  <div v-if="type == 3">
    <div v-for="(item, index) in list" :key="index">
      <div v-if="item[0].type != 1">
        <div class="total_title">{{ item[0].title }}</div>
        <ul class="u4 u4_tit u_title">
          <li class="u4-3">选项</li>
          <li class="u4-3 u4_tit1">人数</li>
        </ul>
        <div class="cnt_list">
          <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in item" :key="index">
            <li class="u4-3">{{ item.category }}</li>
            <li class="u4-3 u4_tit1">{{ item.total }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-if="type == 4">
    <ul class="u4 u4_tit u_title">
      <li class="u4-3">选项</li>
      <li class="u4-3">人数</li>
      <li class="u4-3">比例</li>
    </ul>
    <div class="cnt_list">
      <ul class="u4 u4_tit u_cy u9">
        <li class="u4-3">校外辅导员总人数</li>
        <li class="u4-3">{{ list.total }}</li>
        <li class="u4-3">{{ percentage(item.total) }}%</li>
      </ul>
    </div>
  </div>
  <div v-if="type == 5">
    <ul class="u4 u4_tit u_title">
      <li class="u4-3">选项</li>
      <li class="u4-3">学校总数</li>
      <!-- <li class="u4-3">建队数</li> -->
      <li class="u4-3">建队率</li>
      <!-- <li class="u4-3">辅导员配备数</li> -->
      <li class="u4-3">辅导员配备率</li>
    </ul>
    <div class="cnt_list">
      <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
        <li class="u4-3">{{ format(item.type) }}</li>
        <li class="u4-3">{{ item.teamNum || 0 }}</li>
        <!-- <li class="u4-3">{{ item.schoolBuildingTeam || 0 }}</li> -->
        <li class="u4-3">{{ percent(item.schoolBuildingTeam, item.teamNum) || 0 }} %</li>
        <!-- <li class="u4-3">{{ item.brigadeCounselor || 0 }}</li> -->
        <li class="u4-3">
          {{ percent(item.brigadeCounselor, item.counselorNum) || 0 }}%
        </li>
      </ul>
    </div>
  </div>

  <div v-if="type == 6">
    <div>
      <div>
        <ul class="u4 u4_tit u_title">
          <li class="u4-3">选项</li>
          <li class="u4-3 u4_tit1">数量</li>
        </ul>
        <div class="cnt_list">
          <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
            <li class="u4-3" v-if="index == 'sq'">中队总数</li>
            <li class="u4-3 u4_tit1" v-if="index == 'sq'">{{ item }}</li>

            <li class="u4-3" v-if="index == 'sqcn'">中队辅导员总数</li>
            <li class="u4-3 u4_tit1" v-if="index == 'sqcn'">{{ item }}</li>

            <li class="u4-3" v-if="index == 'yn'">少先队员总数</li>
            <li class="u4-3 u4_tit1" v-if="index == 'yn'">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-if="type == 7">
    <div>
      <div>
        <ul class="u4 u4_tit u_title">
          <li class="u4-3">选项</li>
          <li class="u4-3 u4_tit1">人数</li>
        </ul>
        <div class="cnt_list">
          <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
            <li class="u4-3" v-if="index == 'boc'">校外辅导员总人数</li>
            <li class="u4-3 u4_tit1" v-if="index == 'boc'">{{ item }}</li>

            <li class="u4-3" v-if="index == 'total'">平均每个大队聘请的校外辅导员人数</li>
            <li class="u4-3 u4_tit1" v-if="index == 'total'">{{ averageTotal(list) }}</li>

            <li class="u4-3" v-if="index == 'gte2Num'">2人(含)以上的学校数</li>
            <li class="u4-3 u4_tit1" v-if="index == 'gte2Num'">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-if="type == 8">
    <div>
      <div>
        <ul class="u4 u4_tit u_title">
          <li class="u4-3">选项</li>
          <li class="u4-3 u4_tit1">人数</li>
        </ul>
        <div class="cnt_list">
          <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
            <li class="u4-3" v-if="index == 'sqoc'">辅导员总人数</li>
            <li class="u4-3 u4_tit1" v-if="index == 'sqoc'">{{ item }}</li>
            <li class="u4-3" v-if="index == 'gte2Num'">2人(含)以上的学校数</li>
            <li class="u4-3 u4_tit1" v-if="index == 'gte2Num'">{{ item }}</li>
            <li class="u4-3" v-if="index == 'sq'">平均每个中队聘请的校外辅导员人数</li>
            <li class="u4-3 u4_tit1" v-if="index == 'sq'">{{ sqaverageTotal(list) }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-if="type == 9">
    <div>
      <div>
        <ul class="u4 u4_tit u_title">
          <li class="u4-3">选项</li>
          <li class="u4-3" v-if="titleType == 1">人数</li>
          <li class="u4-3" v-if="titleType == 2">学校数</li>
          <li class="u4-3">比例</li>
        </ul>
        <div class="cnt_list">
          <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
            <li class="u4-3">{{ item.value }}</li>
            <li class="u4-3">{{ item.total || 0 }}</li>
            <li class="u4-3">{{ percentage(item.total) }}%</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-if="type == 10">
    <ul class="u4 u4_tit u_title">
      <li class="u4-3">选项</li>
      <li class="u4-3">地区</li>
      <li class="u4-3">团委担任总数</li>
      <li class="u4-3">总数</li>
      <li class="u4-3">团委担任比例</li>
    </ul>
    <div class="cnt_list">
      <div class="d d_li">
        <label for="" class="label">单主任</label>
        <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list[1]" :key="index">
          <!-- <li class="u4-3">{{ item.levelSGWDirector == 1 ? "单主任" : "双主任" }}</li> -->
          <li class="u4-3">{{ areaFn(item.roleId) }}</li>
          <li class="u4-3">{{ item.jobTotal }}</li>
          <li class="u4-3">{{ item.total }}</li>
          <li class="u4-3">{{ percent(item.jobTotal, item.total) || 0 }}%</li>
        </ul>
      </div>
      <div class="d d_li">
        <label for="" class="label">双主任</label>
        <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list[2]" :key="index">
          <!-- <li class="u4-3">{{ item.levelSGWDirector == 1 ? "单主任" : "双主任" }}</li> -->
          <li class="u4-3">{{ areaFn(item.roleId) }}</li>
          <li class="u4-3">{{ item.jobTotal }}</li>
          <li class="u4-3">{{ item.total }}</li>
          <li class="u4-3">{{ percent(item.jobTotal, item.total) || 0 }}%</li>
        </ul>
      </div>
    </div>
  </div>

  <div v-if="type == 11">
    <div>
      <div>
        <ul class="u4 u4_tit u_title">
          <li class="u4-3">选项</li>
          <li class="u4-3">总数</li>
          <li class="u4-3">平均数</li>
          <!-- <li class="u4-3">已设地区数</li> -->
          <li class="u4-3">未填报数</li>
          <!-- <li class="u4-3">填报比例</li> -->
          <li class="u4-3">未填报比例</li>
        </ul>
        <div class="cnt_list d_mb" v-if="roleId >= 2">
          <ul class="u4 u4_tit u_cy u9">
            <li class="u4-3">全国</li>
            <li class="u4-3">{{ calculationOutSide.numTotal }}</li>
            <li class="u4-3">
              {{ (calculationOutSide.numTotal / calculationOutSide.total).toFixed(2) }}
            </li>
            <!-- <li class="u4-3">{{ calculationOutSide.total }}</li> -->
            <li class="u4-3">{{ calculationOutSide.noCount }}</li>
            <!-- <li class="u4-3">{{ percent(calculationOutSide.total, calculationOutSide.numTotal) }}%</li> -->
            <li class="u4-3">
              {{ percent(calculationOutSide.noCount, calculationOutSide.numTotal) }}%
            </li>
          </ul>
        </div>
        <div class="cnt_list">
          <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
            <li class="u4-3" v-if="item.roleId == 3">省</li>
            <li class="u4-3" v-if="item.roleId == 4">市</li>
            <li class="u4-3" v-if="item.roleId == 5">区</li>
            <li class="u4-3">{{ item.numTotal }}</li>
            <li class="u4-3">{{ (item.numTotal / item.total).toFixed(2) }}</li>
            <!-- <li class="u4-3">{{ item.total }}</li> -->
            <li class="u4-3">{{ item.noCount }}</li>
            <!-- <li class="u4-3">{{ percent(item.total, item.numTotal) }}%</li> -->
            <li class="u4-3">{{ percent(item.noCount, item.numTotal) }}%</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-if="type == 21">
    <div>
      <ul class="u4 u4_tit u_title">
        <li class="u4-3">选项</li>
        <li class="u4-3" v-if="titleType == 1">人数</li>
        <li class="u4-3" v-if="titleType == 2">学校数</li>
        <li class="u4-3">比例</li>
      </ul>
      <div class="cnt_list">
        <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
          <li class="u4-3">
            {{ format(item.type) || "未建队/未配备" }}
          </li>
          <li class="u4-3">{{ item.total || 0 }}</li>
          <li class="u4-3">{{ percentage(item.total) }}%</li>
        </ul>
      </div>
    </div>
  </div>

  <div v-if="type == 22">
    <div>
      <div>
        <ul class="u4 u4_tit u_title">
          <li class="u4-3">地区</li>
          <li class="u4-3">选项</li>
          <li class="u4-3">数量</li>
          <li class="u4-3">比例</li>
        </ul>
        <div class="cnt_list">
          <div class="d d_li d_li2">
            <label for="" class="label">{{ list[3] && "省级" }}</label>
            <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list[3]" :key="index">
              <li class="u4-3">{{ format(item.date) }}</li>
              <li class="u4-3">{{ item.total || 0 }}</li>
              <li class="u4-3">{{ percentFormat(item.total, list[3]) }}%</li>
            </ul>
          </div>
          <div class="d d_li d_li2" >
            <label for="" class="label">{{ list[4] && "市级" }}</label>
            <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list[4]" :key="index">
              <li class="u4-3">{{ format(item.date) }}</li>
              <li class="u4-3">{{ item.total || 0 }}</li>
              <li class="u4-3">{{ percentFormat(item.total, list[4]) }}%</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="type == 23">
    <div>
      <div>
        <ul class="u4 u4_tit u_title">
          <li class="u4-3">选项</li>
          <li class="u4-3">数量</li>
          <li class="u4-3">比例</li>
        </ul>
        <div class="cnt_list">
          <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list" :key="index">
            <li class="u4-3">{{ item.value }}</li>
            <li class="u4-3">{{ item.total || 0 }}</li>
            <li class="u4-3">{{ percentage(item.total) }}%</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-if="type == 24">
    <ul class="u4 u4_tit u_title">
      <li class="u4-3">地区</li>
      <li class="u4-3">选项</li>
      <li class="u4-3">人数</li>
      <li class="u4-3">比例</li>
    </ul>
    <div class="cnt_list">
      <div class="d d_li d_li2" >
        <label for="" class="label">{{ list[3] && "省级" }}</label>
        <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list[3]" :key="index">
          <li class="u4-3">{{ format(item.levelCounselors) }}</li>
          <li class="u4-3">{{ item.total || 0 }}</li>
          <li class="u4-3">{{ percentFormat(item.total, list[3]) }}%</li>
        </ul>
      </div>
      <div class="d d_li d_li2" >
        <label for="" class="label d_bgf">{{ list[4] && "市级" }}</label>
        <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list[4]" :key="index">
          <li class="u4-3">{{ format(item.levelCounselors) }}</li>
          <li class="u4-3">{{ item.total || 0 }}</li>
          <li class="u4-3">{{ percentFormat(item.total, list[4]) }}%</li>
        </ul>
      </div>
      <div class="d d_li d_li2" >
        <label for="" class="label">{{ list[5] && "县级" }}</label>
        <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in list[5]" :key="index">
          <li class="u4-3">{{ format(item.levelCounselors) }}</li>
          <li class="u4-3">{{ item.total || 0 }}</li>
          <li class="u4-3">{{ percentFormat(item.total, list[5]) }}%</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="line"></div>
</template>
<script>
import { watch, reactive, toRefs, onMounted } from "vue";
import _ from "lodash";
import { getRoleId } from "@/common/js";
export default {
  props: {
    list: Array,
    title: String,
    type: Number,
    base: Object,
    titleType: {
      default: 1,
      type: Number,
    },
    totalType: {
      type: Boolean,
      default: false,
    }
    
  },
  setup(props) {
    const state = reactive({
      total: 0,
      calculationOutSide: {},
      roleId: 0,
    });

     onMounted(async () => {
        const r = await getRoleId();
        if(r) {
          state.roleId = r
        }

     })

    watch(props, (newProps) => {
      const { list, type, totalType } = newProps;
      if(totalType) {
        console.log('--', list)
      }

      if (type == 10) {
        console.log("list--", list);
      }
      if (type != 3 && type != 10) {
        if (list && list.length > 0) {
          const total = _.sumBy(list, function (o) {
            if (o.type > 0) {
              return o.total;
            } else {
              return o.total;
            }
          });
          state.total = total;
        }
      }
      if (type == 11 && list.length > 0) {
        const numTotal = _.sumBy(list, function (o) {
          return o.numTotal;
        });
        state.calculationOutSide.numTotal = numTotal;
        const noCount = _.sumBy(list, function (o) {
          return o.noCount;
        });
        state.calculationOutSide.noCount = noCount;
        const total = _.sumBy(list, function (o) {
          return o.total;
        });
        state.calculationOutSide.total = total;
        console.log("state --", state);
      }
    });

    const fixed = (value, num) => {
      if (value == 0) {
        return 0;
      }
      return value.toFixed(num);
    };

    const format = (value) => {
      const { base } = props;
      let t = base.filter((res) => res.key === value);
      if (t.length > 0) {
        return t[0].value;
      } 
      else {
        if (value == -1) {
          return "未建队/未配备";
        }
      }
    };
    const averageTotal = (data) => {
      if (!data) {
        return 0;
      }
      let avg = 0;
      if (data.total != 0 && data.boc != 0) {
        avg = (data.boc / data.total).toFixed(2);
      }
      return avg;
    };

    const sqaverageTotal = (data) => {
      if (!data) {
        return 0;
      }
      let avg = 0;
      if (data.sqoc != 0 && data.sq != 0) {
        avg = (data.sqoc / data.sq).toFixed(2);
      }
      return avg;
    };

    const percentage = (value) => {
      const { total } = state;
      if (value == 0 || total == 0) {
        return 0;
      }
      return ((value / total) * 100).toFixed(2);
    };
    const percentFormat = (total, list = []) => {
      if (total == 0 || list.length == 0) {
        return 0;
      }
      const zTotal = _.sumBy(list, function (o) {
        return o.total;
      });
      return percent(total, zTotal);
    };
    const percent = (value = 0, total = 0) => {
      if (value == 0 || total == 0) {
        return 0;
      }
      let avg = 0;
      if (value != 0 && total != 0) {
        avg = ((value / total) * 100).toFixed(2);
      }
      return avg;
    };
    const areaFn = (type) => {
      if (type == 3) {
        return "省";
      } else if (type == 4) {
        return "市";
      } else if (type == 5) {
        return "县";
      } else {
        return "";
      }
    };
    const percentageTotal = (total, list) => {
       const zTotal = _.sumBy(list, function (o) {
          if (o.type > 0) {
            return o.total;
          } else {
            return 0;
          }
        });
        return percent(total, zTotal)
    }

    return {
      ...toRefs(state),
      percentage,
      format,
      percent,
      averageTotal,
      sqaverageTotal,
      fixed,
      areaFn,
      percentFormat,
      percentageTotal,
    };
  },
};
</script>
<style lang="less" scoped>
@import "@/common/style/mixin";

.u9 {
  background-color: #f8fafc;
  display: flex;
}
.u9:nth-child(2n + 1) {
  background-color: #fff;
}
.u_title {
  background-color: #e5e7eb;
  display: flex;
  border: 1px solid #e5e7eb;
  border-radius: 8px 8px 0 0;
}
.u4_tit {
  height: auto;
  line-height: auto;
}
.u4_tit li {
  border-right: 1px solid #dcdcdc;
  margin-right: -1px;
}
.u4 li {
  width: 50%;
}
.total_title {
  font-size: 0.42rem;
  padding: 0.233rem;
}
.line {
  border-bottom: 1px dashed #dcdcdc;
  margin: 0.5rem 0;
}
.cnt_list {
  border: 1px solid #e5e7eb;
}
.u_cy li {
  min-height: auto;
  line-height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.u4_tit1 {
  border-right: none !important;
}
.d_li {
  padding-left: 20%;
}
.d_li2 {
  padding-left: 25%;
}
.d_li .label {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 20%;
  height: 100%;
  text-align: center;
  border-right: 1px solid #dcdcdc;
  border-top: 1px solid #dcdcdc;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7fafc;
  color: #999;
}
.d_li2 .label {
  width: 25%;
}
.d_mb {
  margin-bottom: -0.05rem;
}
.d_bgf {
  background: #fff !important;
}
</style>
